import React, { useEffect, useState } from 'react';
import { StyleSheet, TouchableOpacity, View, Text } from 'react-native';
import { FONT_STYLE } from '../../dataSchema/const';

const styles = StyleSheet.create({
  container: {
    paddingTop: 15,
  },
  button: {
    width: 42,
    height: 42,
    borderRadius: 10,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 4,
  },
  row: {
    alignSelf: 'center',
  },
  firstRowLabel: {
    marginLeft: 4,
    color: '#FF4C4D',
    textAlign: 'left',
    fontFamily: FONT_STYLE.MEDIUM,
    fontSize: 14
  },
  secondRowLabel: {
    marginRight: 4,
    color: '#0DC98B',
    textAlign: 'right',
    fontFamily: FONT_STYLE.MEDIUM,
    fontSize: 14
  },
  itemContainer: {
    flexDirection: 'row',
    marginVertical: 4,
  },
  npsNumber: {
    fontSize: 16,
    fontFamily: FONT_STYLE.BOLD
  }
});

const LikertItem = ({
  color,
  point,
  selectedPoint,
}: {
  color: string;
  point: number;
  selectedPoint: number;
}) => {
  const selected = selectedPoint === point;
  return (
    <View
      style={[
        styles.button,
        {
          borderColor: color,
          backgroundColor: selected ? color : '#FFFFFF',
        },
      ]}>
      <Text style={[styles.npsNumber, { color: selected ? '#FFFFFF' : color }]}>{point}</Text>
    </View>
  );
};

// Tối ưu render row bằng hàm riêng
const renderLikertRow = (points: number[], colorFn: (item: number) => string, onPress: (item: number) => void, selectedPoint: number) => (
  <View style={styles.itemContainer}>
    {points.map(item => (
      <TouchableOpacity key={item} onPress={() => onPress(item)}>
        <LikertItem
          point={item}
          color={colorFn(item)}
          selectedPoint={selectedPoint}
        />
      </TouchableOpacity>
    ))}
  </View>
);

const LikertBox = ({ onSelect, defaultAnswer = null, startText = "", endText = "" }) => {
  const [selectedPoint, setSelect] = useState(-1)

  const handlePress = (point: number) => {
    if (onSelect) {
      onSelect(point);
    }
    setSelect(point);
  };

  useEffect(() => {
    if (defaultAnswer && defaultAnswer.values) {
      let valueNum = Number.parseInt(defaultAnswer.values[0]);
      setSelect(valueNum);
    }
  }, [])

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <Text style={styles.firstRowLabel}>{startText}</Text>
        {renderLikertRow(
          Array.from({ length: 7 }, (_, i) => i),
          () => '#FF4C4D',
          handlePress,
          selectedPoint
        )}
      </View>
      <View style={styles.row}>
        {renderLikertRow(
          Array.from({ length: 4 }, (_, i) => i + 7),
          (item) => (item < 9 ? '#F7CC15' : '#0DC98B'),
          handlePress,
          selectedPoint
        )}
        <Text style={styles.secondRowLabel}>{endText}</Text>
      </View>
    </View>
  );
};

export default LikertBox;
